/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbInscriptionGridDto } from './FcbInscriptionGridDto';
import {
    FcbInscriptionGridDtoFromJSON,
    FcbInscriptionGridDtoFromJSONTyped,
    FcbInscriptionGridDtoToJSON,
} from './FcbInscriptionGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbInscriptionGridDtoPaginatedResults
 */
export interface FcbInscriptionGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbInscriptionGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbInscriptionGridDto>}
     * @memberof FcbInscriptionGridDtoPaginatedResults
     */
    results?: Array<FcbInscriptionGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbInscriptionGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbInscriptionGridDtoPaginatedResults interface.
 */
export function instanceOfFcbInscriptionGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbInscriptionGridDtoPaginatedResultsFromJSON(json: any): FcbInscriptionGridDtoPaginatedResults {
    return FcbInscriptionGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbInscriptionGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbInscriptionGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbInscriptionGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbInscriptionGridDtoPaginatedResultsToJSON(value?: FcbInscriptionGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbInscriptionGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

